import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SettingsIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g clipPath="url(#a)">
        <path d="M2.942 13.005v6.108M2.942.887v7.389" strokeLinecap="round" />
        <path d="M2.942 12.697a2.064 2.064 0 0 0 2.06-2.069 2.064 2.064 0 0 0-2.06-2.069 2.064 2.064 0 0 0-2.058 2.07c0 1.142.921 2.068 2.058 2.068Z" />
        <path d="M10 8.276v10.837M10 .887v1.478" strokeLinecap="round" />
        <path d="M10 7.39a2.064 2.064 0 0 0 2.059-2.07A2.064 2.064 0 0 0 10 3.251a2.064 2.064 0 0 0-2.059 2.07c0 1.142.922 2.068 2.059 2.068Z" />
        <path d="M17.059 16.551v2.562M17.059.887v9.753" strokeLinecap="round" />
        <path d="M17.059 15.653a2.064 2.064 0 0 0 2.059-2.069 2.064 2.064 0 0 0-2.06-2.069A2.064 2.064 0 0 0 15 13.585c0 1.142.922 2.068 2.059 2.068Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </SVG>
  );
};
